import { Transliteration, Language } from '../types/transliteration';
import { apiClient } from './sutras';

export const transliterationApi = {
    getTransliterations: async (projectName: string, section: string, chapter: number, number: number): Promise<Transliteration[]> => {
        try {
            console.log('Fetching transliterations for:', { projectName, section, chapter, number });
            const transliterations: Transliteration[] = [];
            
            // Fetch transliterations for all supported languages
            for (const lang of Object.values(Language)) {
                try {
                    console.log('Fetching transliteration for language:', lang);
                    const response = await apiClient.get<Transliteration>(
                        `/sutras/${projectName}/${section}/${chapter}/${number}/transliteration?lang=${lang}`
                    );
                    console.log('Response for language', lang, ':', response.data);
                    if (response.data) {
                        transliterations.push({
                            ...response.data,
                            language: lang
                        });
                    }
                } catch (error) {
                    // Skip if transliteration doesn't exist for this language
                    console.debug(`No transliteration found for language ${lang}`, error);
                }
            }
            
            console.log('Final transliterations array:', transliterations);
            return transliterations;
        } catch (error) {
            console.error('Error fetching transliterations:', error);
            return []; // Return empty array on error
        }
    },

    getTransliteration: async (projectName: string, section: string, chapter: number, number: number, language: Language): Promise<Transliteration> => {
        console.log('Fetching single transliteration:', { projectName, section, chapter, number, language });
        const response = await apiClient.get<Transliteration>(
            `/sutras/${projectName}/${section}/${chapter}/${number}/transliteration?lang=${language}`
        );
        console.log('Single transliteration response:', response.data);
        return {
            ...response.data,
            language
        };
    },

    createTransliteration: async (projectName: string, section: string, chapter: number, number: number, transliteration: Omit<Transliteration, 'id' | 'sutra_id'>): Promise<Transliteration> => {
        console.log('Creating transliteration:', { projectName, section, chapter, number, transliteration });
        const requestBody = { ...transliteration, section };
        const response = await apiClient.post<Transliteration>(
            `/sutras/${projectName}/${section}/${chapter}/${number}/transliteration`,
            requestBody
        );
        console.log('Create transliteration response:', response.data);
        return response.data;
    },

    updateTransliteration: async (projectName: string, section: string, chapter: number, number: number, language: Language, transliteration: Transliteration): Promise<Transliteration> => {
        console.log('Updating transliteration:', { projectName, section, chapter, number, language, transliteration });
        const requestBody = { ...transliteration, section };
        const response = await apiClient.put<Transliteration>(
            `/sutras/${projectName}/${section}/${chapter}/${number}/transliteration?lang=${language}`,
            requestBody
        );
        console.log('Update transliteration response:', response.data);
        return response.data;
    },

    deleteTransliteration: async (projectName: string, section: string, chapter: number, number: number, language: Language): Promise<void> => {
        console.log('Deleting transliteration:', { projectName, section, chapter, number, language });
        await apiClient.delete(
            `/sutras/${projectName}/${section}/${chapter}/${number}/transliteration?lang=${language}`
        );
        console.log('Delete transliteration successful');
    }
}; 